export default __webpack_public_path__ + "static/media/robot_think.71b3d063.gif";